import { useState } from 'react';
import styled, { css } from 'styled-components';
import Collapsible from '../Collapsible';
import type { CollapsibleItemBaseProps } from '../Collapsible/index.type';

const AccordionWrapper = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
`;

const StyledItem = styled.li<{ $hasBorder: boolean }>`
  ${({ $hasBorder }) =>
    $hasBorder &&
    css`
    border-bottom: 1px solid #ACACBB; //@todo: web/grey/reg

    &:first-of-type {
      border-top: 1px solid #ACACBB; //@todo: web/grey/reg
    }
  `};
`;

export type AccordionItems = Array<CollapsibleItemBaseProps>;

type AccordionProps = {
  items: AccordionItems;
  hasBorder?: boolean;
};

const Accordion = ({ items, hasBorder = false }: AccordionProps) => {
  const [itemsMap, setItemsMap] = useState<boolean[]>(() => items.map(item => false));

  const clickHandler = (index: number) => {
    setItemsMap(itemsMap.map((_, i) => i === index && !itemsMap[index]));
  };

  return (
    <AccordionWrapper>
      {items.map((item, index) => (
        <StyledItem key={item.id} onClick={() => clickHandler(index)} $hasBorder={hasBorder}>
          <Collapsible
            key={`accordion-item${index}`}
            isExpandedViaParent={itemsMap[index]}
            {...item}
          />
        </StyledItem>
      ))}
    </AccordionWrapper>
  );
};

export default Accordion;
